import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dWeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
import * as Unsafe$dReference from "../Unsafe.Reference/index.js";
import {nextMicrotask} from "./foreign.js";
const traverse = /* #__PURE__ */ (() => Data$dTraversable.traversableArray.traverse(Effect.applicativeEffect))();
const max = x => y => {
  const v = Data$dOrd.ordInt.compare(x)(y);
  if (v.tag === "LT") { return y; }
  if (v.tag === "EQ") { return x; }
  if (v.tag === "GT") { return x; }
  $runtime.fail();
};
const newEvent = /* #__PURE__ */ Specular$dFRP$dBase.newEvent(Effect$dClass.monadEffectEffect);
const updateList = dictMonadFRP => {
  const bind1 = dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind;
  const holdUniqDynBy = Specular$dFRP$dBase.holdUniqDynBy(dictMonadFRP);
  return latestRef => mainSlot => handler => newArray => () => {
    const latest = latestRef.value;
    const a$p = traverse(i => {
      const v = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, newArray, i);
      const v1 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, latest, i);
      if (v1.tag === "Just") {
        if (v.tag === "Just") {
          const $0 = nextMicrotask(v1._1.fire(v._1));
          return () => {
            $0();
            return [];
          };
        }
        if (v.tag === "Nothing") {
          const $0 = v1._1.slot._2;
          return () => {
            $0();
            return [];
          };
        }
        $runtime.fail();
      }
      if (v1.tag === "Nothing") {
        if (v.tag === "Just") {
          const $0 = v._1;
          const $1 = mainSlot._3;
          return () => {
            const slot = $1();
            const v2 = newEvent();
            const result = slot._1(bind1(holdUniqDynBy(Unsafe$dReference.reallyUnsafeRefEq)($0)(v2.event))(dyn => handler(i)(dyn)))();
            return [{slot, fire: v2.fire, result}];
          };
        }
        if (v.tag === "Nothing") { return () => []; }
        $runtime.fail();
      }
      $runtime.fail();
    })(Data$dArray.rangeImpl(0, max(newArray.length)(latest.length)))();
    const $0 = newArray.length;
    const $1 = Data$dSemigroup.concatArray(latest)(Data$dArray.concat(a$p));
    const newLatest = $0 < 1 ? [] : Data$dArray.sliceImpl(0, $0, $1);
    latestRef.value = newLatest;
    return Data$dFunctor.arrayMap(v => v.result)(newLatest);
  };
};
const weakDynamicListWithIndex = dictMonadFRP => {
  const Bind1 = dictMonadFRP.MonadCleanup1().Monad0().Bind1();
  const MonadEffect0 = dictMonadFRP.MonadEffect0();
  const newEvent1 = Specular$dFRP$dBase.newEvent(MonadEffect0);
  const subscribeDyn_ = Specular$dFRP$dBase.subscribeDyn_(dictMonadFRP);
  const updateList1 = updateList(dictMonadFRP);
  const holdWeakDyn = Specular$dFRP$dWeakDynamic.holdWeakDyn(dictMonadFRP);
  return dictMonadReplace => {
    const newSlot = dictMonadReplace.newSlot;
    return dynArray => handler => Bind1.bind(MonadEffect0.liftEffect(() => ({value: []})))(v => Bind1.bind(newSlot)(mainSlot => Bind1.bind(newEvent1)(resultChanged => Bind1.bind((() => {
      const $0 = updateList1(v)(mainSlot)(i => dyn => handler(i)(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(dyn)));
      return subscribeDyn_(Specular$dFRP$dWeakDynamic.traverse_(a => {
        const $1 = $0(a);
        return () => {
          const $2 = $1();
          return resultChanged.fire($2)();
        };
      }))(dynArray);
    })())(() => holdWeakDyn(resultChanged.event)))));
  };
};
const weakDynamicList = dictMonadFRP => {
  const weakDynamicListWithIndex1 = weakDynamicListWithIndex(dictMonadFRP);
  return dictMonadReplace => {
    const weakDynamicListWithIndex2 = weakDynamicListWithIndex1(dictMonadReplace);
    return dynArray => handler => weakDynamicListWithIndex2(dynArray)(v => handler);
  };
};
const weakDynamicListWithIndex_ = dictMonadFRP => {
  const void1 = dictMonadFRP.MonadCleanup1().Monad0().Bind1().Apply0().Functor0().map(v => {});
  const weakDynamicListWithIndex1 = weakDynamicListWithIndex(dictMonadFRP);
  return dictMonadReplace => {
    const weakDynamicListWithIndex2 = weakDynamicListWithIndex1(dictMonadReplace);
    return dynArray => handler => void1(weakDynamicListWithIndex2(dynArray)(handler));
  };
};
const weakDynamicList_ = dictMonadFRP => {
  const void1 = dictMonadFRP.MonadCleanup1().Monad0().Bind1().Apply0().Functor0().map(v => {});
  const weakDynamicListWithIndex1 = weakDynamicListWithIndex(dictMonadFRP);
  return dictMonadReplace => {
    const weakDynamicListWithIndex2 = weakDynamicListWithIndex1(dictMonadReplace);
    return dynArray => handler => void1(weakDynamicListWithIndex2(dynArray)(v => handler));
  };
};
const dynamicListWithIndex_ = dictMonadFRP => {
  const bind1 = dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind;
  const liftEffect = dictMonadFRP.MonadEffect0().liftEffect;
  const subscribeDyn_ = Specular$dFRP$dBase.subscribeDyn_(dictMonadFRP);
  const updateList1 = updateList(dictMonadFRP);
  return dictMonadReplace => {
    const newSlot = dictMonadReplace.newSlot;
    return dynArray => handler => bind1(liftEffect(() => ({value: []})))(v => bind1(newSlot)(mainSlot => subscribeDyn_((() => {
      const $0 = updateList1(v)(mainSlot)(handler);
      return x => {
        const $1 = $0(x);
        return () => {$1();};
      };
    })())(dynArray)));
  };
};
const dynamicList_ = dictMonadFRP => {
  const dynamicListWithIndex_1 = dynamicListWithIndex_(dictMonadFRP);
  return dictMonadReplace => {
    const dynamicListWithIndex_2 = dynamicListWithIndex_1(dictMonadReplace);
    return dynArray => handler => dynamicListWithIndex_2(dynArray)(v => handler);
  };
};
const dynamicListWithIndex = dictMonadFRP => {
  const Monad0 = dictMonadFRP.MonadCleanup1().Monad0();
  const Bind1 = Monad0.Bind1();
  const MonadEffect0 = dictMonadFRP.MonadEffect0();
  const newEvent1 = Specular$dFRP$dBase.newEvent(MonadEffect0);
  const holdDyn = Specular$dFRP$dBase.foldDyn(dictMonadFRP)(x => v => x);
  const subscribeDyn_ = Specular$dFRP$dBase.subscribeDyn_(dictMonadFRP);
  const updateList1 = updateList(dictMonadFRP);
  const pure1 = Monad0.Applicative0().pure;
  return dictMonadReplace => {
    const newSlot = dictMonadReplace.newSlot;
    return dynArray => handler => Bind1.bind(MonadEffect0.liftEffect(() => ({value: []})))(v => Bind1.bind(newSlot)(mainSlot => Bind1.bind(newEvent1)(resultChanged => Bind1.bind(holdDyn([])(resultChanged.event))(result => Bind1.bind(subscribeDyn_((() => {
      const $0 = updateList1(v)(mainSlot)(handler);
      return a => {
        const $1 = $0(a);
        return () => {
          const $2 = $1();
          return resultChanged.fire($2)();
        };
      };
    })())(dynArray))(() => pure1(result))))));
  };
};
const dynamicList = dictMonadFRP => {
  const dynamicListWithIndex1 = dynamicListWithIndex(dictMonadFRP);
  return dictMonadReplace => {
    const dynamicListWithIndex2 = dynamicListWithIndex1(dictMonadReplace);
    return dynArray => handler => dynamicListWithIndex2(dynArray)(v => handler);
  };
};
export {
  dynamicList,
  dynamicListWithIndex,
  dynamicListWithIndex_,
  dynamicList_,
  max,
  newEvent,
  traverse,
  updateList,
  weakDynamicList,
  weakDynamicListWithIndex,
  weakDynamicListWithIndex_,
  weakDynamicList_
};
export * from "./foreign.js";
